// Locale registry. `en`, `es` and `pt` are the legacy locales used by the
// translated legal pages (/es/, /pt/); the others belong to the LATAM site.
// `flag` is the key understood by components/LangButton.
export const LOCALES = {
  en: {
    label: 'English',
    flag: 'EN',
    htmlLang: 'en',
    hreflang: 'en',
    ogLocale: 'en_US',
    suggestion: 'View this page in English',
  },
  es: {
    label: 'Español',
    flag: 'ES',
    htmlLang: 'es',
    hreflang: 'es',
    ogLocale: 'es_ES',
    prefix: '/es/',
    suggestion: 'Ver esta página en Español',
  },
  pt: {
    label: 'Português',
    flag: 'PT',
    htmlLang: 'pt',
    hreflang: 'pt',
    ogLocale: 'pt_BR',
    prefix: '/pt/',
    suggestion: 'Ver esta página em Português',
  },
  // The US site (root pages). Only offered as a link from LATAM pages; it is
  // not part of the LATAM hreflang group nor a browser-language suggestion.
  'en-US': {
    label: 'English (United States)',
    flag: 'EN',
    htmlLang: 'en-US',
    hreflang: 'en-US',
    ogLocale: 'en_US',
    suggestion: 'View this page in English (United States)',
  },
  'en-LATAM': {
    label: 'English (Global)',
    flag: 'GLOBAL',
    htmlLang: 'en',
    hreflang: 'en',
    ogLocale: 'en_US',
    prefix: '/en/',
    suggestion: 'View this page in English',
  },
  'pt-BR': {
    label: 'Português (Brasil)',
    flag: 'PT',
    htmlLang: 'pt-BR',
    hreflang: 'pt-BR',
    ogLocale: 'pt_BR',
    prefix: '/pt-br/',
    suggestion: 'Ver esta página em Português (Brasil)',
  },
  'es-MX': {
    label: 'Español (México)',
    flag: 'MX',
    htmlLang: 'es-MX',
    hreflang: 'es-MX',
    ogLocale: 'es_MX',
    prefix: '/es-mx/',
    suggestion: 'Ver esta página en Español (México)',
  },
  'es-CO': {
    label: 'Español (Colombia)',
    flag: 'CO',
    htmlLang: 'es-CO',
    hreflang: 'es-CO',
    ogLocale: 'es_CO',
    prefix: '/es-co/',
    suggestion: 'Ver esta página en Español (Colombia)',
  },
};

export function getLocaleForRoute(route = '/') {
  const match = Object.keys(LOCALES).find((code) => {
    const { prefix } = LOCALES[code];
    // Home routes arrive without the trailing slash (`/es-co`).
    return prefix && (route + '/').startsWith(prefix);
  });
  return match || 'en';
}

export function getHtmlLangForRoute(route) {
  const locale = getLocaleForRoute(route);
  return LOCALES[locale].htmlLang;
}
